import apiClient from "../../../utils/clients/axios";

export const getAllUserList = async () => {
  const { data } = await apiClient.get("/usertypes");

  return data;
};

export const createUser = async (payload) => {
  const repsponse = await apiClient.post("/users/", payload);

  return repsponse;
};

export const editUser = async (payload) => {
  const response = await apiClient.patch("/users/", payload);

  return response;
};
